export const bannersStyle = theme => ({
  root: {
    marginBottom: theme.spacing(1),
  },

  column: {
    display: 'flex',
    flexDirection: 'column',
  },
})
